import { render } from "./MarkdownViewer.vue?vue&type=template&id=2616b616"
import script from "./MarkdownViewer.vue?vue&type=script&lang=js"
export * from "./MarkdownViewer.vue?vue&type=script&lang=js"

import "./MarkdownViewer.vue?vue&type=style&index=0&id=2616b616&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__